/*
 * Copyright (c) 2024 Cozy Intellect Inc.
 * File Path: packages/ui/src/lib/svelteHelper.ts
 */

import { twMerge } from 'tailwind-merge';

export type ClassNameValue = Parameters<typeof twMerge>[number];

export function classNames(...classes: (string | undefined | ClassNameValue)[]) {
	return twMerge(...classes);
}
